module.exports = __webpack_public_path__ + "static/media/founders-grotesk-web-medium.76e70e07.woff2";